export default "__VITE_ASSET__DFfH6xO4__"